import { ImobiliarioEdificacao } from "../interfaces";
import { TIPO_VINCULO_EDIFICACAO } from "./edificacoesHierarchy";
import {
  getVinculosAtivosDoImobiliario,
  imobiliarioTemPrincipalAtiva,
} from "./vincularEdificacaoRioBranco";

export type AcaoVinculoUnificacaoRioBranco =
  | "principal"
  | "subunidade_imovel"
  | "complementar_principal"
  | "complementar_subunidade";

export interface VinculoUnificacaoConfig {
  acao: AcaoVinculoUnificacaoRioBranco;
  id_edificacao_alvo?: string;
}

export interface VinculoUnificacaoPayloadItem {
  id_imobiliario_edificacao: string | number;
  id_edificacao: string | number;
  acao: AcaoVinculoUnificacaoRioBranco;
  id_edificacao_alvo?: string | number;
}

export function getVinculosAtivosParaUnificacao(
  vinculos: ImobiliarioEdificacao[],
  idImobiliario: string | number,
) {
  return getVinculosAtivosDoImobiliario(vinculos, idImobiliario);
}

export function getLabelTipoVinculo(tipoVinculo: unknown): string {
  const tipo = Number(tipoVinculo);
  if (tipo === TIPO_VINCULO_EDIFICACAO.PRINCIPAL) return "Principal";
  if (tipo === TIPO_VINCULO_EDIFICACAO.SUBUNIDADE) return "Subunidade";
  if (tipo === TIPO_VINCULO_EDIFICACAO.COMPLEMENTAR) return "Complementar";
  return "Vínculo";
}

export function criarConfigPadraoVinculoUnificacao(
  vinculos: ImobiliarioEdificacao[],
  idImobiliarioCorporadora: string | number,
  vinculo: ImobiliarioEdificacao,
): VinculoUnificacaoConfig {
  const corporadoraTemPrincipal = imobiliarioTemPrincipalAtiva(vinculos, idImobiliarioCorporadora);

  if (!corporadoraTemPrincipal && Number(vinculo.tipo_vinculo) === TIPO_VINCULO_EDIFICACAO.PRINCIPAL) {
    return { acao: "principal" };
  }

  if (corporadoraTemPrincipal) {
    return { acao: "subunidade_imovel" };
  }

  return { acao: "principal" };
}

export function buildPayloadVinculosUnificacao(
  vinculos: ImobiliarioEdificacao[],
  configs: Record<string, VinculoUnificacaoConfig>,
): VinculoUnificacaoPayloadItem[] {
  return vinculos.map((vinculo) => {
    const config = configs[String(vinculo.id)] ?? { acao: "complementar_principal" as const };
    const item: VinculoUnificacaoPayloadItem = {
      id_imobiliario_edificacao: vinculo.id!,
      id_edificacao: vinculo.id_edificacao,
      acao: config.acao,
    };

    if (config.acao === "complementar_subunidade" && config.id_edificacao_alvo) {
      item.id_edificacao_alvo = config.id_edificacao_alvo;
    }

    return item;
  });
}
